import { createBaseStore } from '@shared/store/createBaseStore';
import config from '../config';
import { get } from '../api';

const store = createBaseStore(config);
store.commit('SET_DARK_THEME', true);

let sequence = 0;
store.registerModule('publisher', {
  namespaced: true,
  state: () => ({ workspace: null, config: null, accounts: null }),
  getters: {
    workspace: state => state.workspace,
    config: state => state.config,
    accounts: state => state.accounts || [],
    connected: state => (state.accounts || []).filter(account => account.status === 'connected')
  },
  mutations: {
    WORKSPACE(state, value) { state.workspace = value; },
    CONFIG(state, value) { state.config = value; },
    ACCOUNTS(state, value) { state.accounts = value; },
    RESET(state) { state.workspace = null; state.accounts = null; }
  },
  actions: {
    async loadConfig({ state, commit }) {
      if (!state.config) commit('CONFIG', await get('/config'));
      return state.config;
    },
    async loadWorkspace({ state, commit, dispatch, rootGetters }) {
      if (!rootGetters.isAuthenticated) return null;
      const request = ++sequence;
      try {
        const value = await get('/workspace');
        if (request === sequence) {
          const before = state.workspace ? state.workspace.available_credits : null;
          commit('WORKSPACE', value);
          // Keep the shared header balance in step when work settles.
          if (before !== null && before !== value.available_credits) dispatch('fetchCreditBalance', null, { root: true }).catch(() => {});
        }
        return value;
      } catch (error) {
        return null;
      }
    },
    async loadAccounts({ commit, rootGetters }) {
      if (!rootGetters.isAuthenticated) return [];
      const value = await get('/social/accounts');
      commit('ACCOUNTS', value.accounts);
      return value;
    }
  }
});

const identityOf = user => (user ? String(user.site_id) + ':' + String(user.id) : '');
// Start from the persisted session so the first profile refresh does not wipe loaded data.
let identity = identityOf(store.getters.currentUser);
store.subscribe(mutation => {
  if (['SET_USER', 'SET_TOKEN', 'LOGOUT'].indexOf(mutation.type) < 0) return;
  const user = store.getters.currentUser;
  const next = identityOf(user);
  if (next !== identity) {
    identity = next;
    store.commit('publisher/RESET');
  }
  if (user) store.dispatch('publisher/loadWorkspace');
});

export default store;
